import { Injectable } from '@angular/core';
import { ICmsOutletComponent } from '@icms/client/assets/outlet/icms-outlet.component';
import { ICmsCoreIntegrationAbstractService } from './icms-core-integration-abstract.service';

@Injectable({ providedIn: 'root' })
export class ICmsCoreIntegrationOutletService extends ICmsCoreIntegrationAbstractService<ICmsOutletComponent> {}
